import { render, staticRenderFns } from "./GridForTaskListReal.vue?vue&type=template&id=afa8955e&"
import script from "./GridForTaskListReal.vue?vue&type=script&lang=js&"
export * from "./GridForTaskListReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports